import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import moment from 'moment'
import ReactTooltip from 'react-tooltip'
import format from '../../helpers/format'
import Styles from './FlaggedFund.css'

@CSSModules(Styles)
export default class FlaggedFund extends Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    weight: PropTypes.number.isRequired,
    portfolioDate: PropTypes.string,
    totalFunds: PropTypes.number,
    isFamily: PropTypes.bool,
    label: PropTypes.string
  }
  constructor(props){
    super(props)
  }

  render() {
    function renderStatCount(tip, count, _label){
      return <div
        styleName='stat'
        data-multiline
        data-effect='solid'
        data-tip={tip}
        data-for='flaggedfund-tooltip'
      >
        <div styleName='stat-count-wrapper'>
          <div styleName='stat-count'>{count}</div>
        </div>
        <div styleName='stat-label'>{_label}</div>
      </div>
    }

    const type = this.props.isFamily ? 'family' : 'fund'
    const label = this.props.label || 'weapon'

    return (
      <div styleName='stats-wrapper'>
        <div styleName='stats'>

          { (this.props.isFamily) ?
            renderStatCount('Number of funds analyzed from this '+type,
              format.number(this.props.totalFunds), 'funds analyzed' ) : null }

          { (!this.props.isFamily) ? renderStatCount('Total number of '+label+'<br/> stock holdings found in this '+type,
            format.number(this.props.count), label+' stocks found' ) : null}

          { (!this.props.isFamily) ? renderStatCount('Total percent of the '+type+'\'s long-position assets<br/>invested in '+label+' stocks',
            format.perc(this.props.weight), 'of assets flagged' ) : null}

        </div>

        { (!this.props.isFamily)?(
        <div>
          <div styleName='view-more-data'>
            Data as of {moment(this.props.portfolioDate.slice(0,10)).format('D MMM YYYY')}
          </div>
        </div>
        ):null}

        <ReactTooltip id='flaggedfund-tooltip'/>

      </div>
    )
  }
}

